export default __webpack_public_path__ + "assets/0c0c4612b819c056746606ce977280d3/student-living-made-simple-discover-the-benefits-of-cbm-apartments.jpg";